import { combineReducers } from 'redux';
import {FETCH_ABOUT,LOAD_EDIT_ABOUT_DATA} from 'ActionsAbout';

export function AboutReducers(state = [], action){

  switch (action.type) {
    case FETCH_ABOUT:
      return action.payload.resource;
    default:
    return state;
  }
}

export function loadEditAboutData(state = [], action){
  switch (action.type) {
    case LOAD_EDIT_ABOUT_DATA:
      return action.payload;
    default:
    return state;
  }
}
